import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { jsx as ___EmotionJSX } from "@emotion/react";
const FormGroup = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["className"]);

  return ___EmotionJSX("div", _extends({
    className: clsx('CK__FormGroup', className),
    ref: ref
  }, rest));
});
FormGroup.propTypes = {
  className: PropTypes.string
};
export default FormGroup;